export default function PricingButton(props) {
    const { onClick, children } = props;
    return (
        <div className="generic_price_btn clearfix" onClick={onClick}>
            <a>{children}</a>
        </div>
    );
}